export const adminRoutes = [
  {
    path: "/administrator",
    component: () => import("@/views/Adminstrator/List.vue"),
  },
  {
    path: "/administrator/dashboard",
    component: () => import("@/views/Adminstrator/Dashboard.vue"),
  },
  {
    path: "/administrator/create",
    component: () => import("@/views/Adminstrator/Create.vue"),
  },
  {
    path: "/administrator/update/:userReference",
    component: () => import("@/views/Adminstrator/Create.vue"),
  },
  {
    path: "/administrator/accounttransfer",
    component: () => import("@/views/AccountJournal/AccountTransfer.vue"),
  },
  {
    path: "/administrator/accountjournal",
    component: () => import("@/views/AccountJournal/List.vue"),
  },
];
